/**
 * Banner de mantenimiento para servicios de Inteligencia Artificial.
 *
 * OCULTO temporalmente — el componente retorna null. Para reactivarlo,
 * descomentar el bloque de abajo y eliminar el `return null`.
 */
const AiMaintenanceBanner = () => null;

// import React from "react";
// import { Alert, AlertTitle, Box } from "@mui/material";
// import BuildCircleIcon from "@mui/icons-material/BuildCircle";
// import { useTranslation } from "react-i18next";
//
// const AiMaintenanceBanner = ({ sx = {} }) => {
//   const { t } = useTranslation();
//   return (
//     <Box sx={{ mb: 2, ...sx }}>
//       <Alert
//         severity="warning"
//         variant="filled"
//         icon={<BuildCircleIcon fontSize="inherit" />}
//         sx={{
//           borderRadius: 2,
//           boxShadow: 2,
//           "& .MuiAlert-message": { width: "100%" },
//         }}
//       >
//         <AlertTitle sx={{ fontWeight: 700 }}>
//           {t("aiMaintenance.title")}
//         </AlertTitle>
//         {t("aiMaintenance.message")}
//       </Alert>
//     </Box>
//   );
// };

export default AiMaintenanceBanner;
